import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import {
  Grid,
  Typography,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
  Autocomplete,
  Checkbox,
  Box,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomDropzone from "components/Dropzone";
import {
  GradientButton,
  GradientButtonOutline,
} from "components/GradientButton";
import api from "_api";
import Swal from "sweetalert2";
import "assets/css/modal.css";
import SaveIcon from "assets/images/SaveIcon.svg";
import { Image, Switch } from "antd";
import { ZoomIn } from "@mui/icons-material";
import zIndex from "@mui/material/styles/zIndex";

const ModalViewPackageMarketPlace = ({
  open,
  onClose,
  selectedProduct,
  fetchProductData,
}) => {
  const [files1, setFiles1] = useState([]);
  const [files2, setFiles2] = useState([]);
  const [error1, setError1] = useState(null);
  const [initialProductUrls, setInitialProductUrls] = useState([]);
  const [deletedImageIds, setDeletedImageIds] = useState([]);
  const [fetchData, setFetchData] = useState([]);

  const statusOption = [
    { label: "ตรวจสอบ", value: "pending" },
    { label: "อนุมัติ", value: "approved" },
    { label: "ไม่อนุมัติ", value: "rejected" },
  ];

  const productFields = [
    {
      label: "ชื่อแพ็คเกจ",
      name: "name_package",
      type: "text",
      disabled: true,
    },
    // {
    //   label: "รายละเอียด",
    //   name: "detail",
    //   type: "text",
    //   disabled: true,
    // },
    {
      label: "จำนวนเครดิต",
      name: "total_credit",
      type: "text",
      disabled: true,
    },
    {
      label: "จำนวนวัน",
      name: "total_day",
      type: "text",
      disabled: true,
    },
  ];

  const handleImageDelete = (imageId) => {
    setDeletedImageIds(imageId);
  };

  useEffect(() => {
    if (selectedProduct) {
      if (selectedProduct.picture && Array.isArray(selectedProduct.picture)) {
        const productImageUrls = selectedProduct.picture.map(
          (img) => img.picture
        );
        setInitialProductUrls(productImageUrls);
      }
    }
    console.log({ selectedProduct });
  }, [selectedProduct]);

  // console.log("checking picture display in modal", initialProductUrls);
  useEffect(() => {
    if (selectedProduct) {
      formik.setValues({
        name_package: selectedProduct.name_package || "",
        datail: selectedProduct.detail || "",
        total_credit: selectedProduct.total_credit || "",
        total_day: selectedProduct.total_day || "",
        status: selectedProduct.status || "",
      });

      // Set initial image URLs
      if (selectedProduct.confirm_image) {
        setInitialProductUrls(selectedProduct.confirm_image);
      }
    }
  }, [selectedProduct, open]);

  // Formik setup
  const formik = useFormik({
    initialValues: {
      name_package: "",
      detail: "",
      total_credit: "",
      total_day: "",
      status: "",
    },

    onSubmit: async (values, { resetForm }) => {
      try {
        const userResponse =
          await api.super_admin.updateChangeStatusMarketPlaceCompany(
            { status: values.status },
            selectedProduct.marketplace_company_id
          );
        if (userResponse.isStatus) {
          resetForm();
          onClose();
          fetchProductData();
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        alert(`Error submitting form: ${error.message}`);
      }
    },
  });

  const handleCancel = () => {
    const formHasUnsavedChanges = Object.keys(touched).some(
      (field) => touched[field]
    );

    if (formHasUnsavedChanges) {
      Swal.fire({
        html: `
          <div style="display: flex; align-items: center; justify-content: space-between;">
            <!-- Left side icon/picture -->
            <div style="margin-right: 20px;">
              <img src="${SaveIcon}" alt="warning icon" width="300" height="300"/>
            </div>
      
            <!-- Right side text and buttons -->
            <div style="flex: 1;">
              <h2 style="font-size: 24px; color: #333;">ยืนยันการบันทึกหรือไม่</h2>
              <div id="custom-buttons" style="display: flex; justify-content: flex-end; margin-top: 20px;">
                <!-- React buttons will be injected here -->
              </div>
            </div>
          </div>
        `,
        showCancelButton: false, // Disable default buttons
        showConfirmButton: false, // Disable default buttons
        customClass: {
          container: "swal2-container-custom",
        },
        didOpen: () => {
          document.querySelector(".swal2-container-custom").style.zIndex = 1500;

          // Render your React button components after the Swal modal opens
          ReactDOM.render(
            <>
              <GradientButton
                onClick={() => {
                  // Handle cancel behavior
                  Swal.close(); // Close Swal
                }}
                style={{ width: "100%", marginBottom: "10px" }} // Make full width
              >
                ยกเลิก
              </GradientButton>
              <GradientButtonOutline
                onClick={() => {
                  // Close the current Swal first before showing the confirmation Swal
                  Swal.close();
                  formik.resetForm();
                  setFiles1([]); // Clear product images
                  setFiles2([]); // Clear customer images
                  setInitialProductUrls([]); // Clear initial product image URLs
                  setDeletedImageIds([]); // Clear deleted image IDs
                  onClose(); // Close the modal
                }}
                style={{ width: "100%" }}
              >
                ตกลง
              </GradientButtonOutline>
            </>,
            document.getElementById("custom-buttons") // Inject React components into this div
          );
        },
      });
    } else {
      formik.resetForm();
      setFiles1([]); // Clear product images
      setFiles2([]); // Clear customer images
      setInitialProductUrls([]); // Clear initial product image URLs
      // setInitialCustomerUrls([]);
      setDeletedImageIds([]);
      onClose();
    }
  };

  const renderFields = (fields) => {
    return fields.map((field, index) => (
      <React.Fragment key={index}>
        <Grid item xs={12} sm={3}>
          <Typography variant="subtitle1">
            {field.label}
            {field.required && (
              <span style={{ marginLeft: "4px", color: "red" }}>*</span>
            )}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={9}>
          {field.type === "checkbox" ? (
            <Switch
              value={formik.values.status}
              onChange={(checked) => {
                if (!field.disabled) {
                  formik.setFieldValue("status", checked);
                }
              }}
            />
          ) : (
            <TextField
              disabled={field.disabled}
              id={field.name}
              name={field.name}
              type={field.type}
              value={formik.values[field.name]}
              onChange={formik.handleChange}
              {...getFieldProps(field.name)}
              error={
                formik.touched[field.name] && Boolean(formik.errors[field.name])
              }
              helperText={
                formik.touched[field.name] && formik.errors[field.name]
              }
              fullWidth
              InputProps={{
                sx: { height: "40px" },
                inputProps: {
                  style: {
                    "-moz-appearance": "textfield", // Hide up/down arrows in Firefox
                    "-webkit-appearance": "none", // Hide up/down arrows in Chrome/Safari
                    appearance: "none", // Hide up/down arrows in other browsers
                  },
                  // maxLength:
                  //   field.name === "amphure_id"
                  //     ? 13
                  //     : field.name === "district_id"
                  //     ? 10
                  //     : undefined, // Set max length
                  inputMode: field.type === "text" ? "numeric" : undefined, // Ensure numeric keyboard on mobile
                  pattern: field.type === "text" ? "[0-9]*" : undefined, // Restrict input to numbers
                },
              }}
            />
          )}
        </Grid>
      </React.Fragment>
    ));
  };

  // console.log("formik.values display ", formik.values);

  const { errors, touched, getFieldProps, handleSubmit } = formik;

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") onClose();
      }}
      disableEscapeKeyDown
      maxWidth="md"
      fullWidth
      disablePortal
      sx={{
        borderRadius: "8px",
        // zIndex: 1500,
      }}
      // BackdropProps={{
      //   style: { zIndex: 1000 },
      //   position: "absolute",
      // }}
      // PaperProps={{
      //   style: {
      //     zIndex: 2000,
      //   },
      // }}
    >
      <DialogTitle>
        <Typography variant="h4">รายละเอียดการใช้งานแพ็คเกจ</Typography>
      </DialogTitle>
      <DialogContent sx={{ padding: 0, overflow: "visible" }}>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={3} sx={{ padding: 3 }}>
            <Grid item xs={12}>
              <Grid container spacing={2} sx={{ mb: 3, paddingX: 3 }}>
                {renderFields(productFields)}

                <Grid item xs={12} sm={3}>
                  <Typography variant="subtitle1">
                    หลักฐานการชำระเงิน
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={9}>
                  <Image.PreviewGroup
                    preview={{
                      getPopupContainer: () => document.body, // Ensure preview renders outside of dialog
                      zIndex: 3000,
                    }}
                  >
                    <Image
                      src={selectedProduct?.confirm_image}
                      width={100}
                      height={100}
                      style={{
                        position: "absolute", // Ensure it's positioned above other content
                        // zIndex: 3000,
                        cursor: "pointer",
                      }}
                    />
                  </Image.PreviewGroup>
                </Grid>

                <Grid item xs={12} sm={3}>
                  <Typography variant="subtitle1">ผลการตรวจสอบ</Typography>
                </Grid>
                <Grid item xs={12} sm={9}>
                  <Select
                    id="status"
                    name="status"
                    labelId="status-label"
                    value={formik.values.status}
                    onChange={(e) =>
                      formik.setFieldValue("status", e.target.value)
                    }
                    onBlur={formik.handleBlur}
                    sx={{ height: "50px", width: "250px" }}
                  >
                    {statusOption.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <GradientButtonOutline
          variant="outlined"
          sx={{ mr: 1 }}
          onClick={handleCancel}
        >
          ยกเลิก
        </GradientButtonOutline>
        <GradientButton
          variant="contained"
          onClick={formik.handleSubmit}
          type="submit"
        >
          บันทึก
        </GradientButton>
      </DialogActions>
    </Dialog>
  );
};

export default ModalViewPackageMarketPlace;
